/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './suppliers-save.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/material';
import * as i3 from '@angular/flex-layout/flexbox/api/class';
import * as i4 from '@angular/flex-layout/media-query/media-monitor';
import * as i5 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i6 from '@angular/forms';
import * as i7 from '@angular/flex-layout/flexbox/api/layout';
import * as i8 from '@angular/flex-layout/flexbox/api/layout-gap';
import * as i9 from '@angular/common';
import * as i10 from '@angular/flex-layout/flexbox/api/flex';
import * as i11 from '@angular/flex-layout/flexbox/api/layout-wrap';
import * as i12 from '@angular/flex-layout/flexbox/api/flex-align';
import * as i13 from '@angular/router';
import * as i14 from '../../../../../../app/shared/pipes/translate.pipe';
import * as i15 from '@covalent/core/loading/directives/loading.directive';
import * as i16 from '@covalent/core/loading/services/loading.service';
import * as i17 from '../../../../../../app/agatextscreens/purchasing/suppliers/suppliers-save/suppliers-save.component';
import * as i18 from '@covalent/core/dialogs/services/dialog.service';
import * as i19 from '../../../../../../app/agatextscreens/purchasing/suppliers/supplier.service';
import * as i20 from '../../../../../../app/agatextscreens/accounting/branches/branch.service';
import * as i21 from '../../../../../../services/location.service';
import * as i22 from '../../../../../../app/shared/services/authentication.service';
const styles_SuppliersSaveComponent:any[] = [i0.styles];
export const RenderType_SuppliersSaveComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SuppliersSaveComponent,data:{}});
function View_SuppliersSaveComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'md-card-subtitle',
      [['class','bg-grey color-white text-only']],[[2,'mat-card-subtitle',(null as any)]],
      (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),
      0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(16384,(null as any),0,i2.MdCardSubtitle,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(933888,(null as any),0,i3.ClassDirective,
      [i4.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['',' '])),i1.ɵppd(2)],(_ck,_v) => {
    const currVal_1:any = 'bg-grey color-white text-only';
    _ck(_v,3,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_2:any = i1.ɵunv(_v,4,0,_ck(_v,5,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        0),'edit_supplier',_co._authService.getLanguage()));
    _ck(_v,4,0,currVal_2);
  });
}
function View_SuppliersSaveComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'md-card-subtitle',
      [['class','bg-grey color-white text-only']],[[2,'mat-card-subtitle',(null as any)]],
      (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),
      0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(16384,(null as any),0,i2.MdCardSubtitle,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(933888,(null as any),0,i3.ClassDirective,
      [i4.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['',' '])),i1.ɵppd(2)],(_ck,_v) => {
    const currVal_1:any = 'bg-grey color-white text-only';
    _ck(_v,3,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_2:any = i1.ɵunv(_v,4,0,_ck(_v,5,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        0),'create_supplier',_co._authService.getLanguage()));
    _ck(_v,4,0,currVal_2);
  });
}
function View_SuppliersSaveComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i5.View_MdOption_0,i5.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
      [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[25,4]],0,i2.MdOption,[i1.ElementRef,[2,i2.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['','/','']))],(_ck,
      _v) => {
    const currVal_9:any = _v.context.$implicit.id;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit.name;
    const currVal_11:any = _v.context.$implicit.country_name;
    _ck(_v,3,0,currVal_10,currVal_11);
  });
}
function View_SuppliersSaveComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-checkbox',
      [['class','mat-checkbox'],['color','primary'],['flex','']],[[2,'mat-checkbox-indeterminate',
          (null as any)],[2,'mat-checkbox-checked',(null as any)],[2,'mat-checkbox-disabled',
          (null as any)],[2,'mat-checkbox-label-before',(null as any)]],[[(null as any),
          'change']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>_co.selectBranch($event,_v.context.$implicit)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i5.View_MdCheckbox_0,i5.RenderType_MdCheckbox)),i1.ɵprd(5120,(null as any),
      i6.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.MdCheckbox]),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],
      i1.ElementRef],(null as any),(null as any)),i1.ɵdid(4374528,(null as any),0,
      i2.MdCheckbox,[i1.Renderer2,i1.ElementRef,i1.ChangeDetectorRef,i2.FocusOriginMonitor],
      {checked:[0,'checked'],color:[1,'color']},{change:'change'}),(_l()(),i1.ɵted(0,
      ['','\n                    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_4:any = _co.checkBranch(_v.context.$implicit);
    const currVal_5:any = 'primary';
    _ck(_v,3,0,currVal_4,currVal_5);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,3).indeterminate;
    const currVal_1:any = i1.ɵnov(_v,3).checked;
    const currVal_2:any = i1.ɵnov(_v,3).disabled;
    const currVal_3:any = (i1.ɵnov(_v,3).labelPosition == 'before');
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3);
    const currVal_6:any = _v.context.$implicit.name;
    _ck(_v,4,0,currVal_6);
  });
}
function View_SuppliersSaveComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'div',[['class',
      'padded-container'],['fxLayout','column'],['fxLayout.lt-md','column'],['fxLayoutGap',
      '20px'],['fxLayoutGap.lt-md','14px']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i7.LayoutDirective,
      [i4.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,
          'layoutLtMd']},(null as any)),i1.ɵdid(1720320,(null as any),0,i8.LayoutGapDirective,
      [i4.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i7.LayoutDirective]],{gap:[0,
          'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
      0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),
      i1.ɵted((null as any),['\n                    '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),3,'span',[['class','row-subtitle']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(933888,(null as any),0,i3.ClassDirective,
      [i4.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SuppliersSaveComponent_7)),
      i1.ɵdid(802816,(null as any),0,i9.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'column';
    const currVal_1:any = 'column';
    _ck(_v,1,0,currVal_0,currVal_1);
    const currVal_2:any = '20px';
    const currVal_3:any = '14px';
    _ck(_v,2,0,currVal_2,currVal_3);
    const currVal_4:any = 'padded-container';
    _ck(_v,3,0,currVal_4);
    const currVal_5:any = 'row-subtitle';
    _ck(_v,6,0,currVal_5);
    const currVal_7:any = _co.allBranches;
    _ck(_v,11,0,currVal_7);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_6:any = i1.ɵunv(_v,7,0,_ck(_v,8,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
        0),'branches',_co._authService.getLanguage()));
    _ck(_v,7,0,currVal_6);
  });
}
function View_SuppliersSaveComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'md-checkbox',
      [['class','example-margin mat-checkbox'],['color','primary'],['flex','']],[[2,
          'mat-checkbox-indeterminate',(null as any)],[2,'mat-checkbox-checked',(null as any)],
          [2,'mat-checkbox-disabled',(null as any)],[2,'mat-checkbox-label-before',
              (null as any)]],[[(null as any),'change']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>_co.selectBranch($event,_v.context.$implicit)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i5.View_MdCheckbox_0,i5.RenderType_MdCheckbox)),i1.ɵprd(5120,(null as any),
      i6.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.MdCheckbox]),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],
      i1.ElementRef],(null as any),(null as any)),i1.ɵdid(4374528,(null as any),0,
      i2.MdCheckbox,[i1.Renderer2,i1.ElementRef,i1.ChangeDetectorRef,i2.FocusOriginMonitor],
      {value:[0,'value'],color:[1,'color']},{change:'change'}),i1.ɵdid(933888,(null as any),
      0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),
      i1.ɵted(0,['','\n                    ']))],(_ck,_v) => {
    const currVal_4:any = _v.context.$implicit;
    const currVal_5:any = 'primary';
    _ck(_v,3,0,currVal_4,currVal_5);
    const currVal_6:any = 'example-margin';
    _ck(_v,4,0,currVal_6);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,3).indeterminate;
    const currVal_1:any = i1.ɵnov(_v,3).checked;
    const currVal_2:any = i1.ɵnov(_v,3).disabled;
    const currVal_3:any = (i1.ɵnov(_v,3).labelPosition == 'before');
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3);
    const currVal_7:any = _v.context.$implicit.name;
    _ck(_v,5,0,currVal_7);
  });
}
function View_SuppliersSaveComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'div',[['class',
      'padded-container'],['fxLayout','column'],['fxLayout.lt-md','column'],['fxLayoutGap',
      '20px'],['fxLayoutGap.lt-md','14px']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i7.LayoutDirective,
      [i4.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,
          'layoutLtMd']},(null as any)),i1.ɵdid(1720320,(null as any),0,i8.LayoutGapDirective,
      [i4.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i7.LayoutDirective]],{gap:[0,
          'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
      0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),
      i1.ɵted((null as any),['\n                    '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),3,'span',[['class','row-subtitle']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(933888,(null as any),0,i3.ClassDirective,
      [i4.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SuppliersSaveComponent_9)),
      i1.ɵdid(802816,(null as any),0,i9.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'column';
    const currVal_1:any = 'column';
    _ck(_v,1,0,currVal_0,currVal_1);
    const currVal_2:any = '20px';
    const currVal_3:any = '14px';
    _ck(_v,2,0,currVal_2,currVal_3);
    const currVal_4:any = 'padded-container';
    _ck(_v,3,0,currVal_4);
    const currVal_5:any = 'row-subtitle';
    _ck(_v,6,0,currVal_5);
    const currVal_7:any = _co.allBranches;
    _ck(_v,11,0,currVal_7);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_6:any = i1.ɵunv(_v,7,0,_ck(_v,8,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
        0),'branches',_co._authService.getLanguage()));
    _ck(_v,7,0,currVal_6);
  });
}
function View_SuppliersSaveComponent_11(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.saveSupplier()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i5.View_MdButton_0,i5.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
      [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i2.MdButton,[i1.ElementRef,i1.Renderer2,i2.Platform,
          i2.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i2.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(933888,(null as any),0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],(_ck,
      _v) => {
    const currVal_1:any = 'primary';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'bg-blue color-white';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>(<any>(<any>_v.parent).parent).parent).parent),
        0),'create',_co._authService.getLanguage()));
    _ck(_v,5,0,currVal_3);
  });
}
function View_SuppliersSaveComponent_12(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.saveSupplier()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i5.View_MdButton_0,i5.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
      [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i2.MdButton,[i1.ElementRef,i1.Renderer2,i2.Platform,
          i2.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i2.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(933888,(null as any),0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],(_ck,
      _v) => {
    const currVal_1:any = 'primary';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'bg-blue color-white';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>(<any>(<any>_v.parent).parent).parent).parent),
        0),'save',_co._authService.getLanguage()));
    _ck(_v,5,0,currVal_3);
  });
}
function View_SuppliersSaveComponent_10(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),24,'md-card-actions',
      ([] as any[]),[[2,'mat-card-actions',(null as any)]],(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
      [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i2.MdCardActions,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),19,'div',[['class','table-control-buttons'],
              ['fxFlex',''],['fxFlexAlign','start'],['fxFlexAlign.lt-md','center'],
              ['fxLayoutGap','12px']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(1720320,(null as any),0,i8.LayoutGapDirective,[i4.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[8,(null as any)]],{gap:[0,'gap']},(null as any)),
      i1.ɵdid(737280,(null as any),0,i10.FlexDirective,[i4.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i7.LayoutDirective],[3,i11.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),i1.ɵdid(737280,(null as any),0,i12.FlexAlignDirective,
          [i4.MediaMonitor,i1.ElementRef,i1.Renderer2],{align:[0,'align'],alignLtMd:[1,
              'alignLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i3.ClassDirective,
          [i4.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_SuppliersSaveComponent_11)),i1.ɵdid(16384,
          (null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n                        '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SuppliersSaveComponent_12)),
      i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class','bg-red color-white mat-button'],
          ['color','warn'],['md-button','']],[[8,'disabled',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.goBack()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MdButton_0,i5.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i2.MdButton,
          [i1.ElementRef,i1.Renderer2,i2.Platform,i2.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i2.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n                ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = '12px';
        _ck(_v,5,0,currVal_1);
        const currVal_2:any = '';
        _ck(_v,6,0,currVal_2);
        const currVal_3:any = 'start';
        const currVal_4:any = 'center';
        _ck(_v,7,0,currVal_3,currVal_4);
        const currVal_5:any = 'table-control-buttons';
        _ck(_v,8,0,currVal_5);
        const currVal_6:boolean = !_co.isEditMode;
        _ck(_v,11,0,currVal_6);
        const currVal_7:any = _co.isEditMode;
        _ck(_v,14,0,currVal_7);
        const currVal_9:any = 'warn';
        _ck(_v,18,0,currVal_9);
        const currVal_10:any = 'bg-red color-white';
        _ck(_v,20,0,currVal_10);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
        const currVal_8:any = (i1.ɵnov(_v,18).disabled || (null as any));
        _ck(_v,16,0,currVal_8);
        const currVal_11:any = i1.ɵunv(_v,21,0,_ck(_v,22,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
            0),'back',_co._authService.getLanguage()));
        _ck(_v,21,0,currVal_11);
      });
}
function View_SuppliersSaveComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),214,'md-card-content',
      [['fxLayout','column']],[[2,'mat-card-content',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
      [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i2.MdCardContent,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i7.LayoutDirective,[i4.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),64,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i7.LayoutDirective,[i4.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i8.LayoutGapDirective,[i4.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i7.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,11)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i5.View_MdInputContainer_0,i5.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i6.NgForm],[2,i6.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,1,{_mdInputChild:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),
      i1.ɵqud(603979776,3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),
      i1.ɵqud(603979776,5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i10.FlexDirective,[i4.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i7.LayoutDirective],[3,i11.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,21)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,21).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,21)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,21)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,26)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,26)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,26)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentSupplier.name = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i6.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i6.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i6.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i6.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i6.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i6.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i6.NgControl,
          (null as any),[i6.NgModel]),i1.ɵdid(16384,(null as any),0,i6.NgControlStatus,
          [i6.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[1,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i6.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,31)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MdInputContainer_0,i5.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i6.NgForm],[2,i6.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,7,{_mdInputChild:0}),i1.ɵqud(335544320,8,{_placeholderChild:0}),
      i1.ɵqud(603979776,9,{_errorChildren:1}),i1.ɵqud(603979776,10,{_hintChildren:1}),
      i1.ɵqud(603979776,11,{_prefixChildren:1}),i1.ɵqud(603979776,12,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i10.FlexDirective,[i4.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i7.LayoutDirective],[3,i11.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,41)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,41).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,41)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,41)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,46)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,46)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,46)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentSupplier.code = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i6.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i6.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i6.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i6.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i6.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i6.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i6.NgControl,
          (null as any),[i6.NgModel]),i1.ɵdid(16384,(null as any),0,i6.NgControlStatus,
          [i6.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[7,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i6.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,51)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MdInputContainer_0,i5.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i6.NgForm],[2,i6.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,13,{_mdInputChild:0}),i1.ɵqud(335544320,14,{_placeholderChild:0}),
      i1.ɵqud(603979776,15,{_errorChildren:1}),i1.ɵqud(603979776,16,{_hintChildren:1}),
      i1.ɵqud(603979776,17,{_prefixChildren:1}),i1.ɵqud(603979776,18,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i10.FlexDirective,[i4.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i7.LayoutDirective],[3,i11.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,61)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,61).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,61)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,61)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,66)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,66)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,66)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentSupplier.contact_person = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i6.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i6.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i6.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i6.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i6.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i6.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i6.NgControl,
          (null as any),[i6.NgModel]),i1.ɵdid(16384,(null as any),0,i6.NgControlStatus,
          [i6.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[13,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i6.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),40,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i7.LayoutDirective,[i4.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i8.LayoutGapDirective,[i4.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i7.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,77)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i5.View_MdInputContainer_0,i5.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i6.NgForm],[2,i6.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,19,{_mdInputChild:0}),i1.ɵqud(335544320,20,{_placeholderChild:0}),
      i1.ɵqud(603979776,21,{_errorChildren:1}),i1.ɵqud(603979776,22,{_hintChildren:1}),
      i1.ɵqud(603979776,23,{_prefixChildren:1}),i1.ɵqud(603979776,24,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i10.FlexDirective,[i4.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i7.LayoutDirective],[3,i11.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,87)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,87).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,87)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,87)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,92)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,92)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,92)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentSupplier.address = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i6.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i6.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i6.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i6.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i6.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i6.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i6.NgControl,
          (null as any),[i6.NgModel]),i1.ɵdid(16384,(null as any),0,i6.NgControlStatus,
          [i6.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[19,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i6.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),14,'md-select',[['fxFlex','22%'],['name','city_id'],
              ['role','listbox']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',
                  0],[1,'aria-required',0],[1,'aria-disabled',0],[1,'aria-invalid',
                  0],[1,'aria-owns',0],[2,'mat-select-disabled',(null as any)],[2,
                  'mat-select',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'keydown'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,101)._handleClosedKeydown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,101)._onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.currentSupplier.city_id = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i5.View_MdSelect_0,i5.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),
          0,i6.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i6.NgControl,(null as any),[i6.NgModel]),i1.ɵdid(16384,(null as any),
          0,i6.NgControlStatus,[i6.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          (null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i2.MdSelect,[i1.ElementRef,i1.Renderer2,i2.ViewportRuler,i1.ChangeDetectorRef,
              [2,i2.Dir],[2,i6.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,25,{options:1}),i1.ɵppd(2),i1.ɵppd(2),i1.ɵdid(737280,
          (null as any),0,i10.FlexDirective,[i4.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [3,i7.LayoutDirective],[3,i11.LayoutWrapDirective]],{flex:[0,'flex']},
          (null as any)),(_l()(),i1.ɵted(0,['\n                        '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,2,(null as any),View_SuppliersSaveComponent_5)),
      i1.ɵdid(802816,(null as any),0,i9.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(131072,
          i9.AsyncPipe,[i1.ChangeDetectorRef]),(_l()(),i1.ɵted(0,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),64,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i7.LayoutDirective,[i4.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i8.LayoutGapDirective,[i4.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i7.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,119)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i5.View_MdInputContainer_0,i5.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i6.NgForm],[2,i6.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,26,{_mdInputChild:0}),i1.ɵqud(335544320,27,{_placeholderChild:0}),
      i1.ɵqud(603979776,28,{_errorChildren:1}),i1.ɵqud(603979776,29,{_hintChildren:1}),
      i1.ɵqud(603979776,30,{_prefixChildren:1}),i1.ɵqud(603979776,31,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i10.FlexDirective,[i4.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i7.LayoutDirective],[3,i11.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,129)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,129).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,129)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,129)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,134)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,134)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,134)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentSupplier.phone = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i6.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i6.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i6.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i6.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i6.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i6.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i6.NgControl,
          (null as any),[i6.NgModel]),i1.ɵdid(16384,(null as any),0,i6.NgControlStatus,
          [i6.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[26,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i6.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,139)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MdInputContainer_0,i5.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i6.NgForm],[2,i6.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,32,{_mdInputChild:0}),i1.ɵqud(335544320,33,{_placeholderChild:0}),
      i1.ɵqud(603979776,34,{_errorChildren:1}),i1.ɵqud(603979776,35,{_hintChildren:1}),
      i1.ɵqud(603979776,36,{_prefixChildren:1}),i1.ɵqud(603979776,37,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i10.FlexDirective,[i4.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i7.LayoutDirective],[3,i11.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,149)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,149).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,149)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,149)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,154)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,154)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,154)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentSupplier.fax = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i6.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i6.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i6.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i6.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i6.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i6.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i6.NgControl,
          (null as any),[i6.NgModel]),i1.ɵdid(16384,(null as any),0,i6.NgControlStatus,
          [i6.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[32,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i6.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,159)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MdInputContainer_0,i5.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i6.NgForm],[2,i6.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,38,{_mdInputChild:0}),i1.ɵqud(335544320,39,{_placeholderChild:0}),
      i1.ɵqud(603979776,40,{_errorChildren:1}),i1.ɵqud(603979776,41,{_hintChildren:1}),
      i1.ɵqud(603979776,42,{_prefixChildren:1}),i1.ɵqud(603979776,43,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i10.FlexDirective,[i4.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i7.LayoutDirective],[3,i11.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,169)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,169).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,169)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,169)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,174)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,174)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,174)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentSupplier.email = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i6.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i6.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i6.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i6.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i6.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i6.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i6.NgControl,
          (null as any),[i6.NgModel]),i1.ɵdid(16384,(null as any),0,i6.NgControlStatus,
          [i6.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[38,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i6.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),25,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i7.LayoutDirective,[i4.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i8.LayoutGapDirective,[i4.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i7.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),19,'md-input-container',[['fxFlex',
          '47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,185)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i5.View_MdInputContainer_0,i5.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i6.NgForm],[2,i6.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,44,{_mdInputChild:0}),i1.ɵqud(335544320,45,{_placeholderChild:0}),
      i1.ɵqud(603979776,46,{_errorChildren:1}),i1.ɵqud(603979776,47,{_hintChildren:1}),
      i1.ɵqud(603979776,48,{_prefixChildren:1}),i1.ɵqud(603979776,49,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i10.FlexDirective,[i4.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i7.LayoutDirective],[3,i11.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,8,'textarea',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,195)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,195).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,195)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,195)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,200)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,200)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,200)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentSupplier.notes = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i6.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i6.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i6.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i6.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i6.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i6.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i6.NgControl,
          (null as any),[i6.NgModel]),i1.ɵdid(16384,(null as any),0,i6.NgControlStatus,
          [i6.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[44,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i6.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),['Some notes here'])),
      (_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SuppliersSaveComponent_6)),
      i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SuppliersSaveComponent_8)),
      i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n                '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SuppliersSaveComponent_10)),
      i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n            ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = 'column';
        _ck(_v,3,0,currVal_1);
        const currVal_2:any = 'row';
        const currVal_3:any = 'column';
        _ck(_v,6,0,currVal_2,currVal_3);
        const currVal_4:any = '30px';
        const currVal_5:any = '14px';
        _ck(_v,7,0,currVal_4,currVal_5);
        const currVal_6:any = 'padded-container';
        _ck(_v,8,0,currVal_6);
        const currVal_18:any = '22%';
        _ck(_v,18,0,currVal_18);
        const currVal_32:any = _co.currentSupplier.name;
        _ck(_v,23,0,currVal_32);
        const currVal_33:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,26,0,_ck(_v,27,
            0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'name',_co._authService.getLanguage())),
            ' ');
        _ck(_v,26,0,currVal_33);
        const currVal_45:any = '22%';
        _ck(_v,38,0,currVal_45);
        const currVal_59:any = _co.currentSupplier.code;
        _ck(_v,43,0,currVal_59);
        const currVal_60:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,46,0,_ck(_v,47,
            0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'prefix',_co._authService.getLanguage())),
            '');
        _ck(_v,46,0,currVal_60);
        const currVal_72:any = '22%';
        _ck(_v,58,0,currVal_72);
        const currVal_86:any = _co.currentSupplier.contact_person;
        _ck(_v,63,0,currVal_86);
        const currVal_87:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,66,0,_ck(_v,67,
            0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'contact_name',_co._authService.getLanguage())),
            '');
        _ck(_v,66,0,currVal_87);
        const currVal_88:any = 'row';
        const currVal_89:any = 'column';
        _ck(_v,72,0,currVal_88,currVal_89);
        const currVal_90:any = '30px';
        const currVal_91:any = '14px';
        _ck(_v,73,0,currVal_90,currVal_91);
        const currVal_92:any = 'padded-container';
        _ck(_v,74,0,currVal_92);
        const currVal_104:any = '47%';
        _ck(_v,84,0,currVal_104);
        const currVal_118:any = _co.currentSupplier.address;
        _ck(_v,89,0,currVal_118);
        const currVal_119:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,92,0,_ck(_v,
            93,0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'address',_co._authService.getLanguage())),
            '');
        _ck(_v,92,0,currVal_119);
        const currVal_136:any = 'city_id';
        const currVal_137:any = _co.currentSupplier.city_id;
        _ck(_v,97,0,currVal_136,currVal_137);
        const currVal_138:any = i1.ɵinlineInterpolate(2,'',i1.ɵunv(_v,101,0,_ck(_v,
            103,0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'city',_co._authService.getLanguage())),
            ' / ',i1.ɵunv(_v,101,0,_ck(_v,104,0,i1.ɵnov((<any>(<any>_v.parent).parent),
                0),'country',_co._authService.getLanguage())),'');
        _ck(_v,101,0,currVal_138);
        const currVal_139:any = '22%';
        _ck(_v,105,0,currVal_139);
        const currVal_140:any = i1.ɵunv(_v,108,0,i1.ɵnov(_v,109).transform(_co.allCity$));
        _ck(_v,108,0,currVal_140);
        const currVal_141:any = 'row';
        const currVal_142:any = 'column';
        _ck(_v,114,0,currVal_141,currVal_142);
        const currVal_143:any = '30px';
        const currVal_144:any = '14px';
        _ck(_v,115,0,currVal_143,currVal_144);
        const currVal_145:any = 'padded-container';
        _ck(_v,116,0,currVal_145);
        const currVal_157:any = '22%';
        _ck(_v,126,0,currVal_157);
        const currVal_171:any = _co.currentSupplier.phone;
        _ck(_v,131,0,currVal_171);
        const currVal_172:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,134,0,_ck(_v,
            135,0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'phone',_co._authService.getLanguage())),
            '');
        _ck(_v,134,0,currVal_172);
        const currVal_184:any = '22%';
        _ck(_v,146,0,currVal_184);
        const currVal_198:any = _co.currentSupplier.fax;
        _ck(_v,151,0,currVal_198);
        const currVal_199:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,154,0,_ck(_v,
            155,0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'fax',_co._authService.getLanguage())),
            '');
        _ck(_v,154,0,currVal_199);
        const currVal_211:any = '22%';
        _ck(_v,166,0,currVal_211);
        const currVal_225:any = _co.currentSupplier.email;
        _ck(_v,171,0,currVal_225);
        const currVal_226:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,174,0,_ck(_v,
            175,0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'email_address',_co._authService.getLanguage())),
            '');
        _ck(_v,174,0,currVal_226);
        const currVal_227:any = 'row';
        const currVal_228:any = 'column';
        _ck(_v,180,0,currVal_227,currVal_228);
        const currVal_229:any = '30px';
        const currVal_230:any = '14px';
        _ck(_v,181,0,currVal_229,currVal_230);
        const currVal_231:any = 'padded-container';
        _ck(_v,182,0,currVal_231);
        const currVal_243:any = '47%';
        _ck(_v,192,0,currVal_243);
        const currVal_257:any = _co.currentSupplier.notes;
        _ck(_v,197,0,currVal_257);
        const currVal_258:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,200,0,_ck(_v,
            201,0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'notes',_co._authService.getLanguage())),
            '');
        _ck(_v,200,0,currVal_258);
        const currVal_259:any = _co.isEditMode;
        _ck(_v,207,0,currVal_259);
        const currVal_260:boolean = !_co.isEditMode;
        _ck(_v,210,0,currVal_260);
        const currVal_261:boolean = !_co._authService.isViewer();
        _ck(_v,213,0,currVal_261);
      },(_ck,_v) => {
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
        const currVal_7:any = (null as any);
        const currVal_8:any = true;
        const currVal_9:any = i1.ɵnov(_v,11)._isErrorState();
        const currVal_10:any = i1.ɵnov(_v,11)._mdInputChild.focused;
        const currVal_11:any = i1.ɵnov(_v,11)._shouldForward('untouched');
        const currVal_12:any = i1.ɵnov(_v,11)._shouldForward('touched');
        const currVal_13:any = i1.ɵnov(_v,11)._shouldForward('pristine');
        const currVal_14:any = i1.ɵnov(_v,11)._shouldForward('dirty');
        const currVal_15:any = i1.ɵnov(_v,11)._shouldForward('valid');
        const currVal_16:any = i1.ɵnov(_v,11)._shouldForward('invalid');
        const currVal_17:any = i1.ɵnov(_v,11)._shouldForward('pending');
        _ck(_v,10,1,[currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,
            currVal_13,currVal_14,currVal_15,currVal_16,currVal_17]);
        const currVal_19:any = i1.ɵnov(_v,25).ngClassUntouched;
        const currVal_20:any = i1.ɵnov(_v,25).ngClassTouched;
        const currVal_21:any = i1.ɵnov(_v,25).ngClassPristine;
        const currVal_22:any = i1.ɵnov(_v,25).ngClassDirty;
        const currVal_23:any = i1.ɵnov(_v,25).ngClassValid;
        const currVal_24:any = i1.ɵnov(_v,25).ngClassInvalid;
        const currVal_25:any = i1.ɵnov(_v,25).ngClassPending;
        const currVal_26:any = true;
        const currVal_27:any = i1.ɵnov(_v,26).id;
        const currVal_28:any = i1.ɵnov(_v,26).placeholder;
        const currVal_29:any = i1.ɵnov(_v,26).disabled;
        const currVal_30:any = i1.ɵnov(_v,26).required;
        const currVal_31:any = (i1.ɵnov(_v,26).ariaDescribedby || (null as any));
        _ck(_v,20,1,[currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,
            currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31]);
        const currVal_34:any = (null as any);
        const currVal_35:any = true;
        const currVal_36:any = i1.ɵnov(_v,31)._isErrorState();
        const currVal_37:any = i1.ɵnov(_v,31)._mdInputChild.focused;
        const currVal_38:any = i1.ɵnov(_v,31)._shouldForward('untouched');
        const currVal_39:any = i1.ɵnov(_v,31)._shouldForward('touched');
        const currVal_40:any = i1.ɵnov(_v,31)._shouldForward('pristine');
        const currVal_41:any = i1.ɵnov(_v,31)._shouldForward('dirty');
        const currVal_42:any = i1.ɵnov(_v,31)._shouldForward('valid');
        const currVal_43:any = i1.ɵnov(_v,31)._shouldForward('invalid');
        const currVal_44:any = i1.ɵnov(_v,31)._shouldForward('pending');
        _ck(_v,30,1,[currVal_34,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,
            currVal_40,currVal_41,currVal_42,currVal_43,currVal_44]);
        const currVal_46:any = i1.ɵnov(_v,45).ngClassUntouched;
        const currVal_47:any = i1.ɵnov(_v,45).ngClassTouched;
        const currVal_48:any = i1.ɵnov(_v,45).ngClassPristine;
        const currVal_49:any = i1.ɵnov(_v,45).ngClassDirty;
        const currVal_50:any = i1.ɵnov(_v,45).ngClassValid;
        const currVal_51:any = i1.ɵnov(_v,45).ngClassInvalid;
        const currVal_52:any = i1.ɵnov(_v,45).ngClassPending;
        const currVal_53:any = true;
        const currVal_54:any = i1.ɵnov(_v,46).id;
        const currVal_55:any = i1.ɵnov(_v,46).placeholder;
        const currVal_56:any = i1.ɵnov(_v,46).disabled;
        const currVal_57:any = i1.ɵnov(_v,46).required;
        const currVal_58:any = (i1.ɵnov(_v,46).ariaDescribedby || (null as any));
        _ck(_v,40,1,[currVal_46,currVal_47,currVal_48,currVal_49,currVal_50,currVal_51,
            currVal_52,currVal_53,currVal_54,currVal_55,currVal_56,currVal_57,currVal_58]);
        const currVal_61:any = (null as any);
        const currVal_62:any = true;
        const currVal_63:any = i1.ɵnov(_v,51)._isErrorState();
        const currVal_64:any = i1.ɵnov(_v,51)._mdInputChild.focused;
        const currVal_65:any = i1.ɵnov(_v,51)._shouldForward('untouched');
        const currVal_66:any = i1.ɵnov(_v,51)._shouldForward('touched');
        const currVal_67:any = i1.ɵnov(_v,51)._shouldForward('pristine');
        const currVal_68:any = i1.ɵnov(_v,51)._shouldForward('dirty');
        const currVal_69:any = i1.ɵnov(_v,51)._shouldForward('valid');
        const currVal_70:any = i1.ɵnov(_v,51)._shouldForward('invalid');
        const currVal_71:any = i1.ɵnov(_v,51)._shouldForward('pending');
        _ck(_v,50,1,[currVal_61,currVal_62,currVal_63,currVal_64,currVal_65,currVal_66,
            currVal_67,currVal_68,currVal_69,currVal_70,currVal_71]);
        const currVal_73:any = i1.ɵnov(_v,65).ngClassUntouched;
        const currVal_74:any = i1.ɵnov(_v,65).ngClassTouched;
        const currVal_75:any = i1.ɵnov(_v,65).ngClassPristine;
        const currVal_76:any = i1.ɵnov(_v,65).ngClassDirty;
        const currVal_77:any = i1.ɵnov(_v,65).ngClassValid;
        const currVal_78:any = i1.ɵnov(_v,65).ngClassInvalid;
        const currVal_79:any = i1.ɵnov(_v,65).ngClassPending;
        const currVal_80:any = true;
        const currVal_81:any = i1.ɵnov(_v,66).id;
        const currVal_82:any = i1.ɵnov(_v,66).placeholder;
        const currVal_83:any = i1.ɵnov(_v,66).disabled;
        const currVal_84:any = i1.ɵnov(_v,66).required;
        const currVal_85:any = (i1.ɵnov(_v,66).ariaDescribedby || (null as any));
        _ck(_v,60,1,[currVal_73,currVal_74,currVal_75,currVal_76,currVal_77,currVal_78,
            currVal_79,currVal_80,currVal_81,currVal_82,currVal_83,currVal_84,currVal_85]);
        const currVal_93:any = (null as any);
        const currVal_94:any = true;
        const currVal_95:any = i1.ɵnov(_v,77)._isErrorState();
        const currVal_96:any = i1.ɵnov(_v,77)._mdInputChild.focused;
        const currVal_97:any = i1.ɵnov(_v,77)._shouldForward('untouched');
        const currVal_98:any = i1.ɵnov(_v,77)._shouldForward('touched');
        const currVal_99:any = i1.ɵnov(_v,77)._shouldForward('pristine');
        const currVal_100:any = i1.ɵnov(_v,77)._shouldForward('dirty');
        const currVal_101:any = i1.ɵnov(_v,77)._shouldForward('valid');
        const currVal_102:any = i1.ɵnov(_v,77)._shouldForward('invalid');
        const currVal_103:any = i1.ɵnov(_v,77)._shouldForward('pending');
        _ck(_v,76,1,[currVal_93,currVal_94,currVal_95,currVal_96,currVal_97,currVal_98,
            currVal_99,currVal_100,currVal_101,currVal_102,currVal_103]);
        const currVal_105:any = i1.ɵnov(_v,91).ngClassUntouched;
        const currVal_106:any = i1.ɵnov(_v,91).ngClassTouched;
        const currVal_107:any = i1.ɵnov(_v,91).ngClassPristine;
        const currVal_108:any = i1.ɵnov(_v,91).ngClassDirty;
        const currVal_109:any = i1.ɵnov(_v,91).ngClassValid;
        const currVal_110:any = i1.ɵnov(_v,91).ngClassInvalid;
        const currVal_111:any = i1.ɵnov(_v,91).ngClassPending;
        const currVal_112:any = true;
        const currVal_113:any = i1.ɵnov(_v,92).id;
        const currVal_114:any = i1.ɵnov(_v,92).placeholder;
        const currVal_115:any = i1.ɵnov(_v,92).disabled;
        const currVal_116:any = i1.ɵnov(_v,92).required;
        const currVal_117:any = (i1.ɵnov(_v,92).ariaDescribedby || (null as any));
        _ck(_v,86,1,[currVal_105,currVal_106,currVal_107,currVal_108,currVal_109,currVal_110,
            currVal_111,currVal_112,currVal_113,currVal_114,currVal_115,currVal_116,
            currVal_117]);
        const currVal_120:any = i1.ɵnov(_v,99).ngClassUntouched;
        const currVal_121:any = i1.ɵnov(_v,99).ngClassTouched;
        const currVal_122:any = i1.ɵnov(_v,99).ngClassPristine;
        const currVal_123:any = i1.ɵnov(_v,99).ngClassDirty;
        const currVal_124:any = i1.ɵnov(_v,99).ngClassValid;
        const currVal_125:any = i1.ɵnov(_v,99).ngClassInvalid;
        const currVal_126:any = i1.ɵnov(_v,99).ngClassPending;
        const currVal_127:any = i1.ɵnov(_v,101).tabIndex;
        const currVal_128:any = i1.ɵnov(_v,101)._ariaLabel;
        const currVal_129:any = i1.ɵnov(_v,101).ariaLabelledby;
        const currVal_130:any = i1.ɵnov(_v,101).required.toString();
        const currVal_131:any = i1.ɵnov(_v,101).disabled.toString();
        const currVal_132:any = (((i1.ɵnov(_v,101)._control == null)? (null as any): i1.ɵnov(_v,
            101)._control.invalid) || 'false');
        const currVal_133:any = i1.ɵnov(_v,101)._optionIds;
        const currVal_134:any = i1.ɵnov(_v,101).disabled;
        const currVal_135:any = true;
        _ck(_v,96,1,[currVal_120,currVal_121,currVal_122,currVal_123,currVal_124,currVal_125,
            currVal_126,currVal_127,currVal_128,currVal_129,currVal_130,currVal_131,
            currVal_132,currVal_133,currVal_134,currVal_135]);
        const currVal_146:any = (null as any);
        const currVal_147:any = true;
        const currVal_148:any = i1.ɵnov(_v,119)._isErrorState();
        const currVal_149:any = i1.ɵnov(_v,119)._mdInputChild.focused;
        const currVal_150:any = i1.ɵnov(_v,119)._shouldForward('untouched');
        const currVal_151:any = i1.ɵnov(_v,119)._shouldForward('touched');
        const currVal_152:any = i1.ɵnov(_v,119)._shouldForward('pristine');
        const currVal_153:any = i1.ɵnov(_v,119)._shouldForward('dirty');
        const currVal_154:any = i1.ɵnov(_v,119)._shouldForward('valid');
        const currVal_155:any = i1.ɵnov(_v,119)._shouldForward('invalid');
        const currVal_156:any = i1.ɵnov(_v,119)._shouldForward('pending');
        _ck(_v,118,1,[currVal_146,currVal_147,currVal_148,currVal_149,currVal_150,
            currVal_151,currVal_152,currVal_153,currVal_154,currVal_155,currVal_156]);
        const currVal_158:any = i1.ɵnov(_v,133).ngClassUntouched;
        const currVal_159:any = i1.ɵnov(_v,133).ngClassTouched;
        const currVal_160:any = i1.ɵnov(_v,133).ngClassPristine;
        const currVal_161:any = i1.ɵnov(_v,133).ngClassDirty;
        const currVal_162:any = i1.ɵnov(_v,133).ngClassValid;
        const currVal_163:any = i1.ɵnov(_v,133).ngClassInvalid;
        const currVal_164:any = i1.ɵnov(_v,133).ngClassPending;
        const currVal_165:any = true;
        const currVal_166:any = i1.ɵnov(_v,134).id;
        const currVal_167:any = i1.ɵnov(_v,134).placeholder;
        const currVal_168:any = i1.ɵnov(_v,134).disabled;
        const currVal_169:any = i1.ɵnov(_v,134).required;
        const currVal_170:any = (i1.ɵnov(_v,134).ariaDescribedby || (null as any));
        _ck(_v,128,1,[currVal_158,currVal_159,currVal_160,currVal_161,currVal_162,
            currVal_163,currVal_164,currVal_165,currVal_166,currVal_167,currVal_168,
            currVal_169,currVal_170]);
        const currVal_173:any = (null as any);
        const currVal_174:any = true;
        const currVal_175:any = i1.ɵnov(_v,139)._isErrorState();
        const currVal_176:any = i1.ɵnov(_v,139)._mdInputChild.focused;
        const currVal_177:any = i1.ɵnov(_v,139)._shouldForward('untouched');
        const currVal_178:any = i1.ɵnov(_v,139)._shouldForward('touched');
        const currVal_179:any = i1.ɵnov(_v,139)._shouldForward('pristine');
        const currVal_180:any = i1.ɵnov(_v,139)._shouldForward('dirty');
        const currVal_181:any = i1.ɵnov(_v,139)._shouldForward('valid');
        const currVal_182:any = i1.ɵnov(_v,139)._shouldForward('invalid');
        const currVal_183:any = i1.ɵnov(_v,139)._shouldForward('pending');
        _ck(_v,138,1,[currVal_173,currVal_174,currVal_175,currVal_176,currVal_177,
            currVal_178,currVal_179,currVal_180,currVal_181,currVal_182,currVal_183]);
        const currVal_185:any = i1.ɵnov(_v,153).ngClassUntouched;
        const currVal_186:any = i1.ɵnov(_v,153).ngClassTouched;
        const currVal_187:any = i1.ɵnov(_v,153).ngClassPristine;
        const currVal_188:any = i1.ɵnov(_v,153).ngClassDirty;
        const currVal_189:any = i1.ɵnov(_v,153).ngClassValid;
        const currVal_190:any = i1.ɵnov(_v,153).ngClassInvalid;
        const currVal_191:any = i1.ɵnov(_v,153).ngClassPending;
        const currVal_192:any = true;
        const currVal_193:any = i1.ɵnov(_v,154).id;
        const currVal_194:any = i1.ɵnov(_v,154).placeholder;
        const currVal_195:any = i1.ɵnov(_v,154).disabled;
        const currVal_196:any = i1.ɵnov(_v,154).required;
        const currVal_197:any = (i1.ɵnov(_v,154).ariaDescribedby || (null as any));
        _ck(_v,148,1,[currVal_185,currVal_186,currVal_187,currVal_188,currVal_189,
            currVal_190,currVal_191,currVal_192,currVal_193,currVal_194,currVal_195,
            currVal_196,currVal_197]);
        const currVal_200:any = (null as any);
        const currVal_201:any = true;
        const currVal_202:any = i1.ɵnov(_v,159)._isErrorState();
        const currVal_203:any = i1.ɵnov(_v,159)._mdInputChild.focused;
        const currVal_204:any = i1.ɵnov(_v,159)._shouldForward('untouched');
        const currVal_205:any = i1.ɵnov(_v,159)._shouldForward('touched');
        const currVal_206:any = i1.ɵnov(_v,159)._shouldForward('pristine');
        const currVal_207:any = i1.ɵnov(_v,159)._shouldForward('dirty');
        const currVal_208:any = i1.ɵnov(_v,159)._shouldForward('valid');
        const currVal_209:any = i1.ɵnov(_v,159)._shouldForward('invalid');
        const currVal_210:any = i1.ɵnov(_v,159)._shouldForward('pending');
        _ck(_v,158,1,[currVal_200,currVal_201,currVal_202,currVal_203,currVal_204,
            currVal_205,currVal_206,currVal_207,currVal_208,currVal_209,currVal_210]);
        const currVal_212:any = i1.ɵnov(_v,173).ngClassUntouched;
        const currVal_213:any = i1.ɵnov(_v,173).ngClassTouched;
        const currVal_214:any = i1.ɵnov(_v,173).ngClassPristine;
        const currVal_215:any = i1.ɵnov(_v,173).ngClassDirty;
        const currVal_216:any = i1.ɵnov(_v,173).ngClassValid;
        const currVal_217:any = i1.ɵnov(_v,173).ngClassInvalid;
        const currVal_218:any = i1.ɵnov(_v,173).ngClassPending;
        const currVal_219:any = true;
        const currVal_220:any = i1.ɵnov(_v,174).id;
        const currVal_221:any = i1.ɵnov(_v,174).placeholder;
        const currVal_222:any = i1.ɵnov(_v,174).disabled;
        const currVal_223:any = i1.ɵnov(_v,174).required;
        const currVal_224:any = (i1.ɵnov(_v,174).ariaDescribedby || (null as any));
        _ck(_v,168,1,[currVal_212,currVal_213,currVal_214,currVal_215,currVal_216,
            currVal_217,currVal_218,currVal_219,currVal_220,currVal_221,currVal_222,
            currVal_223,currVal_224]);
        const currVal_232:any = (null as any);
        const currVal_233:any = true;
        const currVal_234:any = i1.ɵnov(_v,185)._isErrorState();
        const currVal_235:any = i1.ɵnov(_v,185)._mdInputChild.focused;
        const currVal_236:any = i1.ɵnov(_v,185)._shouldForward('untouched');
        const currVal_237:any = i1.ɵnov(_v,185)._shouldForward('touched');
        const currVal_238:any = i1.ɵnov(_v,185)._shouldForward('pristine');
        const currVal_239:any = i1.ɵnov(_v,185)._shouldForward('dirty');
        const currVal_240:any = i1.ɵnov(_v,185)._shouldForward('valid');
        const currVal_241:any = i1.ɵnov(_v,185)._shouldForward('invalid');
        const currVal_242:any = i1.ɵnov(_v,185)._shouldForward('pending');
        _ck(_v,184,1,[currVal_232,currVal_233,currVal_234,currVal_235,currVal_236,
            currVal_237,currVal_238,currVal_239,currVal_240,currVal_241,currVal_242]);
        const currVal_244:any = i1.ɵnov(_v,199).ngClassUntouched;
        const currVal_245:any = i1.ɵnov(_v,199).ngClassTouched;
        const currVal_246:any = i1.ɵnov(_v,199).ngClassPristine;
        const currVal_247:any = i1.ɵnov(_v,199).ngClassDirty;
        const currVal_248:any = i1.ɵnov(_v,199).ngClassValid;
        const currVal_249:any = i1.ɵnov(_v,199).ngClassInvalid;
        const currVal_250:any = i1.ɵnov(_v,199).ngClassPending;
        const currVal_251:any = true;
        const currVal_252:any = i1.ɵnov(_v,200).id;
        const currVal_253:any = i1.ɵnov(_v,200).placeholder;
        const currVal_254:any = i1.ɵnov(_v,200).disabled;
        const currVal_255:any = i1.ɵnov(_v,200).required;
        const currVal_256:any = (i1.ɵnov(_v,200).ariaDescribedby || (null as any));
        _ck(_v,194,1,[currVal_244,currVal_245,currVal_246,currVal_247,currVal_248,
            currVal_249,currVal_250,currVal_251,currVal_252,currVal_253,currVal_254,
            currVal_255,currVal_256]);
      });
}
function View_SuppliersSaveComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),35,'md-card',([] as any[]),
      [[2,'mat-card',(null as any)]],(null as any),(null as any),i5.View_MdCard_0,
      i5.RenderType_MdCard)),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,[[2,
      i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i2.MdCard,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵeld(0,(null as any),0,27,
          'md-card-header',[['fxLayout','column']],[[2,'mat-card-header',(null as any)]],
          (null as any),(null as any),i5.View_MdCardHeader_0,i5.RenderType_MdCardHeader)),
      i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i2.MdCardHeader,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i7.LayoutDirective,[i4.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),1,15,'md-card-title',([] as any[]),[[2,'mat-card-title',
          (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i2.MdCardTitle,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          10,'span',[['class','md-title'],['fxFlex','100']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(737280,(null as any),
          0,i10.FlexDirective,[i4.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i7.LayoutDirective],
              [3,i11.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),i1.ɵdid(933888,
          (null as any),0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['','  /\n                        '])),
      i1.ɵppd(2),(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'a',([] as any[]),
          [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,19).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i13.RouterLinkWithHref,
          [i13.Router,i13.ActivatedRoute,i9.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),(_l()(),i1.ɵted((null as any),['',' '])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),[' / ','\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵted(2,['\n                '])),(_l()(),
          i1.ɵand(16777216,(null as any),1,1,(null as any),View_SuppliersSaveComponent_2)),
      i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted(2,['\n                '])),(_l()(),
          i1.ɵand(16777216,(null as any),1,1,(null as any),View_SuppliersSaveComponent_3)),
      i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted(2,['\n            '])),(_l()(),i1.ɵted(0,
          ['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),
          View_SuppliersSaveComponent_4)),i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(0,['\n        ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_2:any = 'column';
        _ck(_v,7,0,currVal_2);
        const currVal_4:any = '100';
        _ck(_v,14,0,currVal_4);
        const currVal_5:any = 'md-title';
        _ck(_v,15,0,currVal_5);
        const currVal_9:any = _ck(_v,20,0,'/purchasing/suppliers');
        _ck(_v,19,0,currVal_9);
        const currVal_12:any = _co.isEditMode;
        _ck(_v,27,0,currVal_12);
        const currVal_13:boolean = !_co.isEditMode;
        _ck(_v,30,0,currVal_13);
        const currVal_14:any = _co.currentSupplier;
        _ck(_v,34,0,currVal_14);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
        const currVal_1:any = true;
        _ck(_v,4,0,currVal_1);
        const currVal_3:any = true;
        _ck(_v,9,0,currVal_3);
        const currVal_6:any = i1.ɵunv(_v,16,0,_ck(_v,17,0,i1.ɵnov((<any>_v.parent),
            0),'purchasing',_co._authService.getLanguage()));
        _ck(_v,16,0,currVal_6);
        const currVal_7:any = i1.ɵnov(_v,19).target;
        const currVal_8:any = i1.ɵnov(_v,19).href;
        _ck(_v,18,0,currVal_7,currVal_8);
        const currVal_10:any = i1.ɵunv(_v,21,0,_ck(_v,22,0,i1.ɵnov((<any>_v.parent),
            0),'suppliers',_co._authService.getLanguage()));
        _ck(_v,21,0,currVal_10);
        const currVal_11:any = ((_co.isEditMode && _co.currentSupplier)? _co.currentSupplier.name: _co.title);
        _ck(_v,23,0,currVal_11);
      });
}
export function View_SuppliersSaveComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i14.TranslatePipe,([] as any[])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),9,'div',[['fxLayout','column']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i7.LayoutDirective,
      [i4.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n    \n    '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),5,'div',[['class','boxed-content-wrapper cards-no-gaps']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(933888,(null as any),0,i3.ClassDirective,[i4.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SuppliersSaveComponent_1)),
      i1.ɵdid(212992,(null as any),0,i15.TdLoadingDirective,[i1.ViewContainerRef,i1.TemplateRef,
          i16.TdLoadingService],{name:[0,'name'],type:[1,'type'],mode:[2,'mode'],strategy:[3,
          'strategy'],color:[4,'color']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    const currVal_0:any = 'column';
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = 'boxed-content-wrapper cards-no-gaps';
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = 'loading';
    const currVal_3:any = 'circle';
    const currVal_4:any = 'indeterminate';
    const currVal_5:any = 'overlay';
    const currVal_6:any = 'accent';
    _ck(_v,8,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  },(null as any));
}
export function View_SuppliersSaveComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-suppliers-new',
      ([] as any[]),(null as any),(null as any),(null as any),View_SuppliersSaveComponent_0,
      RenderType_SuppliersSaveComponent)),i1.ɵdid(114688,(null as any),0,i17.SuppliersSaveComponent,
      [i18.TdDialogService,i16.TdLoadingService,i19.SupplierService,i20.BranchService,
          i21.LocationService,i13.ActivatedRoute,i9.Location,i22.AuthenticationService],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const SuppliersSaveComponentNgFactory:i1.ComponentFactory<i17.SuppliersSaveComponent> = i1.ɵccf('app-suppliers-new',
    i17.SuppliersSaveComponent,View_SuppliersSaveComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/purchasing/suppliers/suppliers-save/suppliers-save.component.ngfactory.ts